<div class="export-dialog">
  <h2>Marschzeittabellen erstellen</h2>

  @if (error_message != "") {
    <div class="error-banner" role="alert">
      <p id="status_message" class="error_message">
        {{ error_message }}
      </p>
      <button mat-stroked-button color="warn" (click)="retry_after_error()">
        Nochmals versuchen
      </button>
    </div>
  }

  <form [formGroup]="options" class="settings-form-container">
    <!-- Marschzeittabelle + Elevation Profile in one card -->
    <div class="marschzeit-card">
      <app-walk-time-table [formGroup]="options" (userEdited)="onUserEdited()">
      </app-walk-time-table>

      <app-elevation-profile></app-elevation-profile>
    </div>

    @if (showAdvancedSettings) {
      <div class="content-block mt-4">
        <p>
          Hier kannst du einstellen, wo die Legende im Höhenprofil angezeigt
          wird. Das Höhenprofil wird deinem Export als Bild beigefügt.
        </p>
        <mat-select
          appearance="fill"
          placeholder="Position der Legende"
          formControlName="legend_position"
        >
          <mat-option value="upper left">Oben Links</mat-option>
          <mat-option value="lower left">Unten Links</mat-option>
          <mat-option value="upper right">Oben Rechts</mat-option>
          <mat-option value="lower right">Unten Rechts</mat-option>
        </mat-select>
      </div>
    }

    <div
      class="action-buttons-container"
      style="justify-content: flex-start; margin-bottom: 32px"
    >
      <button
        mat-button
        type="button"
        (click)="showAdvancedSettings = !showAdvancedSettings"
        class="btn-advanced"
        disableRipple
      >
        <mat-icon>{{
          showAdvancedSettings ? "expand_less" : "expand_more"
        }}</mat-icon>
        Erweiterte Einstellungen
      </button>
    </div>

    <div class="settings-section">
      <h3 class="section-title">Einstellungen zur Karte</h3>
      <div class="settings-grid">
        <div class="settings-card">
          <mat-slide-toggle formControlName="auto_scale"
            >Massstab automatisch wählen</mat-slide-toggle
          >
          <mat-slide-toggle formControlName="name_points_in_export"
            >Punkte beschriften</mat-slide-toggle
          >
          <mat-slide-toggle formControlName="number_points_in_export"
            >Punkte nummerieren</mat-slide-toggle
          >
          <div class="slider-container">
            <label
              >Kartenmassstab:
              {{
                options.value.auto_scale ? "automatisch" : "1:" + slider.value
              }}</label
            >
            <mat-slider
              min="5000"
              max="100000"
              step="5000"
              [disabled]="options.value.auto_scale"
            >
              <input matSliderThumb #slider formControlName="map_scaling" />
            </mat-slider>
          </div>
        </div>
        <div class="settings-card">
          <p>Kartenlayer auswählen:</p>
          <mat-select
            appearance="fill"
            placeholder="Kartenlayer"
            formControlName="map_layers"
          >
            <mat-option value="ch.swisstopo.pixelkarte-farbe"
              >Basiskarte Farbig</mat-option
            >
            <mat-option value="ch.swisstopo.pixelkarte-grau"
              >Basiskarte S/W</mat-option
            >
            <mat-option value="ch.swisstopo.swissimage-product"
              >Luftbild</mat-option
            >
            <mat-option
              value="ch.swisstopo.pixelkarte-farbe,ch.bafu.wrz-wildruhezonen_portal,ch.bafu.bundesinventare-auen,ch.bafu.bundesinventare-hochmoore,ch.bafu.bundesinventare-flachmoore,ch.bafu.bundesinventare-jagdbanngebiete,ch.bafu.schutzgebiete-schweizerischer_nationalpark,ch.bafu.bundesinventare-trockenwiesen_trockenweiden"
            >
              Wildruhezonen
            </mat-option>
            <mat-option
              value="ch.swisstopo.vec200-miscellaneous,ch.swisstopo.vec200-names-namedlocation,ch.swisstopo.vec25-gebaeude,ch.swisstopo.swisstlm3d-eisenbahnnetz,ch.swisstopo.swisstlm3d-gewaessernetz,ch.swisstopo.swisstlm3d-uebrigerverkehr,ch.swisstopo.swisstlm3d-wald,ch.swisstopo.swisstlm3d-strassen,ch.swisstopo.swisstlm3d-wanderwege,ch.swisstopo.vec25-heckenbaeume,ch.swisstopo.geologie-geotope"
            >
              Minimale Karte
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>

    <div class="settings-section export-action-section">
      <button
        mat-flat-button
        type="button"
        color="primary"
        class="btn-primary-pill"
        [disabled]="!route_uploaded"
        id="export-button"
        (click)="download_map()"
      >
        Herunterladen
      </button>
    </div>
  </form>
</div>
